import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { MagnifyingGlassIcon, XIcon } from '@/icons';
import { Input } from '@/ui/components/input';
import { Button } from '@/ui_v3';
export interface SearchInputRef {
  focus: () => void;
}
export const SearchInput = forwardRef<SearchInputRef, {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  isSearchButtonVisible: boolean;
}>(({
  value,
  onChange,
  onSearch,
  isSearchButtonVisible
}, ref) => {
  const {
    t
  } = useTranslation(['build']);
  const inputRef = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    }
  }));
  const showXIcon = !!value;
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };
  const handleClickXIcon = () => {
    onChange('');
    inputRef.current?.focus();
  };
  useEffect(() => {
    // 검색 탭으로 전환 시 바로 Input에 focus
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 10);
    return () => clearTimeout(timer);
  }, []);
  return <Input ref={inputRef} id="image-search-input" placeholder={t('image.searchTab.placeholder')} className="mb-lg min-h-[58px] w-full outline outline-[1px] outline-offset-[-1px] outline-[#E9EAF2] focus-within:outline-[2px] focus-within:outline-offset-[-2px] focus-within:outline-[#A49BFF]" inputClassName="text-heading-sm-bold placeholder:text-input-label-placeholder" value={value} onChange={e => onChange(e.target.value)} onKeyDown={handleKeyPress} leftSlot={<MagnifyingGlassIcon size="md" fill={ICON_COLOR.neutral} />} rightSlot={<div className="flex items-center">
          {showXIcon && <div className="flex size-[40px] cursor-pointer items-center justify-center" onClick={handleClickXIcon}>
              <XIcon size="md" fill={ICON_COLOR.neutral} />
            </div>}
          {isSearchButtonVisible && <Button size="md" variant="outlined" intent="neutral" onClick={onSearch}>
              {t('image.searchTab.button')}
            </Button>}
        </div>} />;
});
SearchInput.displayName = 'SearchInput';